import type {DefaultError, UseMutationOptions} from '@tanstack/react-query'
import {useMutation} from '@tanstack/react-query'

import {fetchAcceptOffer} from '../../../api'
import type {AcceptOfferRequest} from '../../../api/dcaa/repo/types'
import type {DeliveryIds, FormState} from '../../../api/definitions/form'
import type {AppConfig} from '../../../types'

export function useAcceptOffer(
  appConfig: AppConfig,
  options?: Omit<UseMutationOptions<DeliveryIds, DefaultError, AcceptOfferRequest>, 'mutationFn'>,
) {
  function fetchAccept(body: {offers: {id: string}[]; state: FormState; mode: string}) {
    return fetchAcceptOffer(appConfig, body)
  }
  return useMutation({...options, mutationFn: fetchAccept})
}
